import { useTranslation } from "react-i18next";
import "./LanguageSelect.css";

const LanguageSelect = () => {
    const { t, i18n } = useTranslation();
    const selectedLanguage = (i18n.resolvedLanguage || i18n.language).startsWith("en") ? "en" : "fi";

    const changeLanguage = (event) => {
        const language = event.target.value;
        window.localStorage.setItem("portfolio-language", language);
        i18n.changeLanguage(language);
    };

    return (
        <div className="languageSelect">
            <label className="srOnly" htmlFor="language-select">{t("languageSelect.label")}</label>
            <select
                id="language-select"
                value={selectedLanguage}
                onChange={changeLanguage}
                aria-label={t("languageSelect.label")}
            >
                <option value="fi">🇫🇮 Suomi</option>
                <option value="en">🇬🇧 English</option>
            </select>
        </div>
    );
};

export default LanguageSelect;
